var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.announs.length)?_c('div',{staticClass:"announs"},[_vm._l((_vm.announs),function(item,i){return [_vm._v(" "+_vm._s(item.description)+" ")]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }